import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { CONSENT_PROPERTY_API } from "./apiRoutes";

interface getProps {
  communityId: string;
  propertyId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getConsentDtl = async (communityId: string, propertyId: string) =>
  await axiosAuth.get(`${CONSENT_PROPERTY_API(communityId, propertyId)}/consent`);

const useGetConsentDtl = ({
  communityId,
  propertyId,
  queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["consent-dtl", communityId],
    queryFn: () => getConsentDtl(communityId, propertyId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!propertyId && (queryParams?.enabled ?? true),
  });
};

export default useGetConsentDtl;
